import { ApiPagedResponse } from "./api-paged-response.model";

/*
    Carries pagination information to different components. The is created from the ApiPagedResponseData, or can be created outside for paging communication
    On usages, check budget-plan (outlook) views where label changes creates new pagination info
*/
export class PaginationInfo {

    constructor(
        pageIndex: number = 0,
        pageSize: number = 0,
        totalCount: number = 0,
        totalPages: number = 0,
        hasPreviousPage: boolean = false,
        hasNextPage: boolean = false
    ) {
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.totalCount = totalCount;
        this.totalPages = totalPages;
        this.hasPreviousPage = hasPreviousPage;
        this.hasNextPage = hasNextPage;
    }

    pageIndex: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;

    public static createForApiPagedResponse(response: ApiPagedResponse<any>): PaginationInfo {
        let paginationInfo = new PaginationInfo(response.pageIndex, response.pageSize, response.totalCount, response.totalPages, response.hasPreviousPage, response.hasNextPage);
        return paginationInfo;
    }

    get showingFrom(): number {
        let from: number = (this.pageIndex * this.pageSize) + 1;
        return from;
    }

    get showingTo(): number {
        let to: number = (this.pageIndex + 1) * this.pageSize;
        if (to > this.totalCount)
            return this.totalCount;

        return to;
    }

    get showPageIndex(): number {
        return this.pageIndex + 1;
    }
}


// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/pagination-info.model.ts